import React, { FC, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { useLayout } from '../../layout/core';
import { toAbsoluteUrl } from '../../utils';
import { AsideMenu } from './AsideMenu';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { SelectPicker } from 'rsuite';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { useTranslation } from 'react-i18next';
import { BASE_URL } from '../../../config/environmentConfig';
import { fetchListOfMerchants, setChosenMerchant } from '../../store/merchnts/actions/merchant';
import { ADMIN_GROUPS } from '../../views/login/Login';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesLeft } from '@fortawesome/free-solid-svg-icons';

const AsideDefault: FC = () => {
	const { config, classes } = useLayout();
	const { aside } = config;

	const userData: any = useSelector<RootState>(({ auth }) => auth.userData, shallowEqual);
	const isSuperAdmin = userData?.userGroups?.some(el => el === ADMIN_GROUPS.SUPER_ADMIN);
	const isPartnerAdmin = userData?.userGroups?.some(el => el === ADMIN_GROUPS.PARTNER_ADMIN);
	const isIntegrationPartner = userData?.userGroups?.some(el => el === ADMIN_GROUPS.INTEGRATION_PARTNER_ADMIN);

	const { merchantState: { listOfMerchants, isListOfMerchantsLoading }} = useMerchants();
	const { t } = useTranslation();
	const { dispatch } = useMerchants();
	const [merchant, setMerchant] = useState<string >('');
	const [isHiddenBar, setIsHiddenBar] = useState<boolean >(false);

	useEffect(() => {
		// TODO check partners permissions
		(isSuperAdmin || isPartnerAdmin || isIntegrationPartner) && fetchListOfMerchants(dispatch);
	}, []);

	useEffect(() => {
		setChosenMerchant(dispatch, merchant);
	}, [merchant]);

	const containerRef = useRef();
	return (
		<div
			id="kt_aside"
			className={clsx('aside', classes.aside.join(' '))}
			data-kt-drawer="true"
			data-kt-drawer-name="aside"
			data-kt-drawer-activate="{default: true, lg: false}"
			data-kt-drawer-overlay="true"
			data-kt-drawer-width="{default:'200px', '300px': '250px'}"
			data-kt-drawer-direction="start"
			data-kt-drawer-toggle="#kt_aside_mobile_toggle"
			ref={containerRef}
		>
			{/* begin::Brand */}
			<div className="aside-logo flex-column-auto" id="kt_aside_logo">
				{/* begin::Logo */}
				{/*<Link to="/">*/}
					<img
						alt="Logo"
						className="logo w-120px"
						src={toAbsoluteUrl('/media/flex-logo-small.svg')}
					/>
				{/*</Link>*/}
				{/* end::Logo */}

				{/* begin::Aside toggler */}

				{aside.minimize && (
					<div
						id="kt_aside_toggle"
						className="btn btn-icon w-auto px-0 btn-active-color-danger aside-toggle"
						data-kt-toggle="true"
						data-kt-toggle-state="active"
						data-kt-toggle-target="body"
						data-kt-toggle-name="aside-minimize"
						onClick={(): void => setIsHiddenBar(prev => !prev)}
					>
						<FontAwesomeIcon icon={faAnglesLeft} className={clsx('aside-icon-collapse', isHiddenBar ? 'rotate-minus-180' : 'rotate-0')}/>
					</div>
				)}
				{/* end::Aside toggler */}
			</div>
			{/* end::Brand */}
			{
				(isSuperAdmin || isPartnerAdmin) && (
					<div className="px-7 pt-5 d-lg-none merchants-selector main-merchant-filter-selector">
						<SelectPicker
							data={listOfMerchants}
							container={(): any => containerRef.current}
							appearance="subtle"
							placeholder={t('ORDERS.SELECT_MERCHANT')}
							onSelect={(value): void => setMerchant(value)}
							onClean={(): void => setMerchant(undefined)}
							defaultValue={merchant}
							disabled={isListOfMerchantsLoading}
							placement="bottomStart"
							searchBy={(keyword, label, item): boolean => {
								return String(item.label).toLowerCase().includes(keyword.toLowerCase()) || String(item.value).toLowerCase().includes(keyword.toLowerCase());
							}}
							renderMenuItem={(label, item): JSX.Element =>
								<span className={item.isActive ? 'active-menu-item' : 'inactive-menu-item'}>{label}</span>}
						/>
					</div>
				)
			}
			<div className="menu-item d-none d-lg-block">
				<div className="menu-content">
					<div className="separator mx-1 my-4"/>
				</div>
			</div>

			{/* begin::Aside menu */}
			<div className="aside-menu flex-column-fluid">
				<AsideMenu asideMenuCSSClasses={classes.asideMenu}/>
			</div>
			{/* end::Aside menu */}
			{
				isSuperAdmin
					? (
						<div className="menu-item d-lg-none">
							<Link
								to="/release-notes"
								className="menu-link without-sub ms-5"
							>
								<span className="menu-gray-600">{BASE_URL.APP_VERSION}</span>
							</Link>
						</div>
					) : (
						<span className="ms-12 mb-3 d-lg-none">{BASE_URL.APP_VERSION}</span>
					)
			}
		</div>
	);
};

export { AsideDefault };
